"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    dir: 'rtl',
    close: 'סגירה',
    cancel: 'ביטול',
    save: 'אישור',
    schoolYear: 'שנת לימוד',
    selectCustomDate: 'בחירת תאריך מותאם',
    anotherDate: 'תאריך אחר',
    semester: 'סמסטר',
    A: 'א׳',
    B: 'ב׳',
    C: 'ג׳',
    rangeDatePickerTitle: 'בחירת תאריך מותאם',
    rangeDatePickerStartLabel: 'תאריך התחלה',
    rangeDatePickerEndLabel: 'תאריך סיום'
  },
  ar: {
    dir: 'rtl',
    close: 'إغلاق',
    cancel: 'ضبط',
    save: 'حفظ',
    schoolYear: 'العام الدراسي',
    selectCustomDate: 'حدد تاريخًا مخصصًا',
    anotherDate: 'تاريخ آخر',
    semester: 'الفصل',
    A: 'الأول',
    B: 'الثاني',
    C: 'الثالث',
    rangeDatePickerTitle: 'حدد تاريخًا مخصصًا',
    rangeDatePickerStartLabel: 'تاريخ البدء',
    rangeDatePickerEndLabel: 'تاريخ الانتهاء'
  },
  en: {
    dir: 'ltr',
    close: 'close',
    cancel: 'cancel',
    save: 'save',
    schoolYear: 'School year',
    selectCustomDate: 'Select a custom date',
    anotherDate: 'Another date',
    semester: 'semester',
    A: 'A',
    B: 'B',
    C: 'C',
    rangeDatePickerTitle: 'Select a custom date',
    rangeDatePickerStartLabel: 'Start Date',
    rangeDatePickerEndLabel: 'End date'
  }
};